import Icon from '../components/Icon.vue'

Icon.register({"hand-point-right":{"width":512,"height":512,"paths":[{"d":"M512 199.7C512 223.3 491.4 243.5 467.2 243.5H367.3C383.7 260.5 385.7 293.2 361.1 314.4 375.3 337.3 363.2 367.4 344.6 376.7 353.6 425.9 322.7 448 272 448 269.3 448 258.7 447.8 256 447.8 194 448 179.1 416.7 132.3 409.5 120.6 407.7 112 397.6 112 385.8V214.3L112 214.3C112 195.9 122.6 178.4 140.5 170.4 169.4 157.4 235.9 121.4 248 93.1 255.8 74.9 269.4 64 288 64 322.2 64 345.8 99.1 332.1 130.9 328.5 139.3 323.8 147.6 318 155.8H467.2C490.6 155.8 512 176.4 512 199.7zM96 200V392C96 405.3 85.3 416 72 416H24C10.7 416 0 405.3 0 392V200C0 186.7 10.7 176 24 176H72C85.3 176 96 186.7 96 200zM68 368C68 357 59 348 48 348S28 357 28 368 37 388 48 388 68 379 68 368z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/hand-point-right.js
// module id = null
// module chunks = 